export const STATE_USER = 'state-user';
